export enum ScenarioStatisticShortcut {
	fund = 'fund',
	funds = 'funds',
	portfolio = 'portfolio',
	portfolios = 'portfolios',
	portfoliosBarChartData = 'portfoliosBarChartData',
	portfoliosMptStatistics = 'portfoliosMptStatistics',
	portfolioCompositeFund = 'portfolioCompositeFund',
	portfolioCorrelation = 'portfolioCorrelation',
	entityRisksTable = 'entityRisksTable',
	portfoliosScatterChartData = 'portfoliosScatterChartData',
}